export default __webpack_public_path__ + "static/media/complementary--camera--g3.859735f8.png";